import { MiniGameId, MiniGameMount } from './types';
import {
  MINI_GAME_KICKER,
  MINI_GAME_TUTORIAL_KICKER,
  MINI_GAMES_NEW,
  MINI_GAMES_TUTORIAL,
} from './constants';

export type MiniGameKind = 'game' | 'tutorial';

export interface IMiniGameEntry {
  id: MiniGameId;
  kind: MiniGameKind;
  title: string;
  blurb: string;
  badge: string | null;
  requiresKeyboard: boolean;
}

export const TUTORIAL_ID: MiniGameId = 'controls';

export const MINI_GAMES: IMiniGameEntry[] = [
  {
    id: 'lock',
    kind: 'game',
    title: 'Unlock',
    blurb: 'Tap in rhythm · 30-second rounds',
    badge: null,
    requiresKeyboard: false,
  },
  {
    id: 'stack',
    kind: 'game',
    title: 'Stack',
    blurb: 'Drop each block on the tower · go high',
    badge: MINI_GAMES_NEW,
    requiresKeyboard: false,
  },
  {
    id: 'slice',
    kind: 'game',
    title: 'Slice',
    blurb: 'Cut each shape exactly in half · 3 shapes',
    badge: MINI_GAMES_NEW,
    requiresKeyboard: false,
  },
  {
    id: TUTORIAL_ID,
    kind: 'tutorial',
    title: MINI_GAMES_TUTORIAL,
    blurb: 'Move, look around and turn the camera',
    badge: null,
    requiresKeyboard: true,
  },
];

export const miniGameOf = (id: MiniGameId): IMiniGameEntry =>
  MINI_GAMES.find((game) => game.id === id) ?? MINI_GAMES[0];

export const kickerOf = (game: IMiniGameEntry): string =>
  game.kind === 'tutorial' ? MINI_GAME_TUTORIAL_KICKER : MINI_GAME_KICKER;

export const pickableGames = (touch: boolean): IMiniGameEntry[] =>
  MINI_GAMES.filter(
    (game) => game.kind === 'game' && !(touch && game.requiresKeyboard),
  );

export const tutorialOffered = (touch: boolean): boolean =>
  !(touch && miniGameOf(TUTORIAL_ID).requiresKeyboard);

const LOADERS: Record<MiniGameId, () => Promise<{ mount: MiniGameMount }>> = {
  controls: () => import('./controls'),
  lock: () => import('./lock'),
  stack: () => import('./stack'),
  slice: () => import('./slice'),
};

export const loadMiniGame = (id: MiniGameId): Promise<MiniGameMount> =>
  LOADERS[id]().then((module) => module.mount);
